import React, { useId } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const DisabledFieldWrapper = ({
  disabled,
  tooltip,
  className,
  style,
  wrapperProps = {},
  tooltipClassName = 'responder-tooltip responder-tooltip--center-arrow',
  placement = 'top-start',
  disabledClassName = 'opacity-50',
  disabledStyle = { cursor: 'not-allowed' },
  children,
}) => {
  const tooltipId = useId();
  const { className: wrapperClassNameProp, style: wrapperStyleProp, ...restWrapperProps } =
    wrapperProps;
  const mergedClassName = [
    className,
    wrapperClassNameProp,
    disabled ? disabledClassName : null,
  ]
    .filter(Boolean)
    .join(' ');
  const mergedStyle = {
    ...(disabled ? disabledStyle : null),
    ...style,
    ...wrapperStyleProp,
  };

  const content = (
    <div className={mergedClassName || undefined} style={mergedStyle} {...restWrapperProps}>
      {children}
    </div>
  );

  if (!disabled || !tooltip) {
    return content;
  }

  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip className={tooltipClassName} id={tooltipId}>
          {tooltip}
        </Tooltip>
      }
    >
      {content}
    </OverlayTrigger>
  );
};

export default DisabledFieldWrapper;
